import type { QueryString } from 'server/types';

export const FRAGMENT_PREFIX = '/mfe/content-renderer/fragments';
export const EXPERIENCE_FRAGMENT_PREFIX = '/content/experience-fragments/waitrosegroceriescms';

export type BespokeContentFragmentPath = {
  /**
   * Path to the content fragment in AEM.
   */
  path: string;
  /**
   * Query parameters to append to the request.
   */
  query?: QueryString;
  /**
   * Additional styles to apply to the content. The style names are derived from the webpack entry point.
   */
  styles?: string[];
};

export const BESPOKE_CONTENT_FRAGMENT_PATHS: Record<string, BespokeContentFragmentPath> = {
  '/sitewide-banner': {
    path: `${EXPERIENCE_FRAGMENT_PREFIX}/Site-Wide-Banner/Site-Banner-Content/master`,
    query: { location: 'siteWideBannerContent' },
  },
};

export const PATHS = {
  health: '/health',
  statics: '/ecom/assets/mfe/content-renderer/',
  fragment: `${FRAGMENT_PREFIX}/*`,
  page: `/ecom/*`,
  metrics: '/metrics',
} as const;

export const EXCLUDED_PATHS = [PATHS.health, PATHS.statics, PATHS.metrics] as const;
